<template>
  <el-container>
    <!-- nav -->
    <el-aside width="140px" :class="collapsed?'menu-collapsed':'menu-expanded'">
      <div class="pa_logo_box" @click="backMian">
        <div class="name" style="font-size:14px">{{merchant_name}}</div>
      </div>
      <!--导航菜单-->
      <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
               unique-opened router v-show="!collapsed">
        <template v-for="(item,index) in $router.options.routes" :index="index" v-if="!item.hidden">
          <el-menu-item :class="navRouter.path == item.path?'is-active':''" :index="item.path" :key="item.path" v-if="!item.hidden">
            <i :class="item.iconCls"></i>{{item.name}}
          </el-menu-item>
        </template>
      </el-menu>
      <!--导航菜单-折叠后-->
      <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
        <li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" :index="index" class="el-submenu item">
          <template v-if="!item.leaf">
            <div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
            <ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)">
              <li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
            </ul>
          </template>
          <template v-else>
        <li class="el-submenu">
          <div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 45px;line-height: 45px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
        </li>
</template>
</li>
</ul>
<div class="pa_nav_user_info_box footer">
<el-dropdown trigger="hover">
  <div class="el-dropdown-link userinfo-inner">
    <img v-if="merchant_user_avatar" class="img" :src="merchant_user_avatar" />
    <img v-else class="img" src="../assets/avatar_null.png" />
    <div class="info">
      <span style="font-size:12px;" class="myName" >{{merchant_user_name}}</span>
      <span>{{user.post}}</span>
    </div>
    <i class="el-icon-arrow-right"></i>
  </div>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item @click.native="btnMyCenter">个人中心</el-dropdown-item>
    <el-dropdown-item @click.native="updatePassword">修改密码</el-dropdown-item>
    <el-dropdown-item divided @click.native="selectShop" >切换店铺</el-dropdown-item>
    <el-dropdown-item divided @click.native="logout">退出系统</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
</div>
</el-aside>
<!-- nav end-->
<el-container>
<!-- header -->
<el-header  class="pa_header_box" style="height:60px; padding-top:10px;">
  <el-col v-show="pathLength > 3" :span="24" class="breadcrumb-container">
    <el-breadcrumb separator="/" class="breadcrumb-inner">
      <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
        <a style="font-weight:bold;" v-if="$route.path != item.path" @click="routeLink(item)">{{ item.name }}</a>
        <span v-else>{{ item.name }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </el-col>
  <el-form v-show="pathLength < 4" :inline="true">
    <el-form-item v-for="(item,index) in navRouter.children" :key="index" v-if="!item.hidden">
      <router-link class="pa_link" :class="colorHeightCheck(item)?'on':''" :to="item.path">{{item.name}}{{ item.title }}</router-link>
    </el-form-item>
  </el-form>
</el-header>
<!-- header end  -->
<!-- main -->
<el-main>
  <div class="grid-content bg-purple-light">
    <el-col :span="24" class="content-wrapper">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </el-col>
  </div>
</el-main>
<!-- main end -->
</el-container>

<personCenter :status="addEmployeeStatus"  @add="addPersonCenter"  ></personCenter>
<updateMi :status="updateMiStatus"  @add="addUpdateMi" ></updateMi>
</el-container>
</template>

<script>
import { appendImg } from '../common/js/util';
import personCenter from '@/components/account/personCenter.vue';
import updateMi from '@/components/account/updateMi.vue';
import config from '../api/config';
export default {
  components:{
    personCenter,
    updateMi,
  },
  data() {
    return {
      addEmployeeStatus:false,
      updateMiStatus:false,
      merchant_logo_url:'',
      merchant_name:'',
      merchant_user_name:'',
      merchant_user_avatar:'',
      sysName:'管理后台',
      collapsed:false,
      pathLength:'',
      user:{},
      navRouter:{},
      form: {
        name: '',
        region: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    }
  },
  beforeUpdate(){
    this.showNavItems()
  },
  created() {
    this.showNavItems();
    this.showLoginData();
  },
  updated(){
    if(localStorage.getItem("updateToken")==12){
      this.showLoginData();
      localStorage.removeItem("updateToken")
    }
  },
  methods: {
    backMian(){
      if(this.$router.options.routes){
        let routes = this.$router.options.routes
        for (let x in routes) {
          if(this.navRouter.path != routes[x].path && routes[x].hidden == false ){
            this.$router.push({'path':routes[x].path})
            return
          }
        }
      }
    },
    routeLink(item){
      if(this.$route.path.indexOf('service/stock') != -1){
        this.$router.push({'path':'/service/stock'})
      }else{
        this.$router.go(-1);
      }
    },
    colorHeightCheck (current) {
      if (this.$route.path == current.path) {
        return true;
      }
      if (typeof(current.children) != 'undefined') {
        for (let i = 0;i < current.children.length; i++) {
          if (current.children[i].path == this.$route.path) {
            return true;
          }
        }
      }
      return false;
    },
    addPersonCenter(lev){
      this.addEmployeeStatus = lev
    },
    addUpdateMi(lev){
      this.updateMiStatus = lev
    },

    btnMyCenter(){
      this.addEmployeeStatus=true;
    },
    updatePassword(){
      this.updateMiStatus=true;
    },
    showLoginData(){
      var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'));
      this.merchant_name = tokenInfo.merchant_name;
      this.merchant_logo_url = tokenInfo.merchant_logo?appendImg(tokenInfo.merchant_logo):'';
      this.merchant_user_name = tokenInfo.merchant_user_name?tokenInfo.merchant_user_name:'修改资料';
      this.merchant_user_avatar = tokenInfo.merchant_user_avatar?appendImg(tokenInfo.merchant_user_avatar):'';
    },
    showNavItems() {
      const _this = this;
      this.pathLength = this.$route.path.split('/').length;
      var urlPath = '/'+this.$route.path.split('/')[1];
      this.$router.options.routes.map((item,imdex)=>{
        if(item.path == urlPath){
          _this.navRouter = item;
        }
      })
    },
    handleopen() {

    },
    handleclose() {
    },
    handleselect: function (a, b) {

    },
    selectShop:function(){
      var _this = this;
      this.$confirm('确认切换店铺吗?', '提示', {
        //type: 'warning'
      }).then(() => {
        var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'));
        if(tokenInfo.api_login === '1'){
          localStorage.removeItem('tokenInfo');
          var url = config.bms_url+'/bms-select-shop';
          window.location.href = url;
        }else{
          _this.$router.push('/select');
        }
      }).catch(() => {

      });
    },
    //退出登录
    logout: function () {
      var _this = this;
      this.$confirm('确认退出吗?', '提示', {
        //type: 'warning'
      }).then(() => {
        var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'));
        _this.$ajax({
          'method' : 'com.set.merchant.basic.logout',
          'data': {}
        }).then(res => {
          if(tokenInfo.api_login === '1'){
            var url = config.bms_url;
            window.location.href = url;
          }else{
            _this.$router.push('/login');
            localStorage.removeItem("acc");
            localStorage.removeItem("passW");

          }
        })
        localStorage.removeItem('tokenInfo');
      }).catch(() => {

      });
    },
    //折叠导航栏
    collapse:function(){
      this.collapsed = !this.collapsed;
    },
    showMenu(i,status){
      this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
    }
  },
  mounted() {
    var user = sessionStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      this.user = user;
    }
  }
}

</script>

<style scoped lang="scss">
@import '~scss_vars';
.el-container{height:100%;background:#f8f8f8;}
.el-aside,.el-footer{background:#fff;}
.el-aside{padding-bottom:90px;}
.el-menu{border:0;}
img{max-width:100%;}

.pa_header_box{background:#fff;}
.pa_header_box .breadcrumb-inner{line-height:40px;}
.pa_logo_box{padding:20px 0;text-align:center;font-size:18px;}
.pa_logo_box .logo{width:60px;height:60px;margin:0 auto;border-radius:50%;}

.pa_nav_user_info_box{
  bottom:10px;left:10px;width:120px;
  .el-dropdown{width:100%;}
  .userinfo-inner{
    display:flex;background:#F8F8F8;padding:10px;align-items:center;
    .img{
      width:30px;height:30px;border-radius:50%;margin-right:10px;
    }
    .el-icon-arrow-right{position:absolute;right:2px;font-size:20px;}
    .info span{display:block;}
  }
}
.pa_link{padding:0 10px;font-size:14px;color:#999;}
.pa_link.on{color:#FF700B;}
.myName{
  display: inline-block;
  width:4.7rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.footer{position:fixed;bottom:0}
</style>



// WEBPACK FOOTER //
// Home.vue?bc9e70cc